import React from 'react';
import { Button } from '@mui/material';
import styled from 'styled-components';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const BackButton = styled(Button).attrs({
  startIcon: <ArrowBackIcon color="primary" />,
})`
  text-transform: none;
  color: #b2b2b2;
`;

export default BackButton;
